export default {
  notMe: '¿No eres {name}?',
  login: 'Acesso',
  actual: 'Espanol'
}
